import LGraph from './src/main'

LGraph.install = function(Vue) {
  Vue.component(LGraph.name, LGraph)
}

export default LGraph
